import $ from "jquery";
import { getCookie, setCookie } from "./utils";
import "bootstrap/js/dist/tooltip";

let currentCookie;
let prefersDarkScheme;
const mediaQueryList = window.matchMedia("(prefers-color-scheme: dark)");

const _switchActiveClass = (id) => {
	for (const element of document.querySelectorAll(
		`div.theme-switcher div.grid__item:not(${id})`,
	)) {
		element.classList.remove("active");
	}
	if (document.querySelector(`${id}`))
		document.querySelector(`${id}`).classList.add("active");
};

const _changeListener = (e) => {
	if (e.matches) {
		document.documentElement.classList.add("dark-mode");
	} else {
		document.documentElement.classList.remove("dark-mode");
	}
};

// SwitchColoreScheme
(() => {
	currentCookie = getCookie("color-scheme");
	prefersDarkScheme = window.matchMedia("(prefers-color-scheme: dark)");
	if (currentCookie) {
		if (currentCookie === "dark") {
			document.documentElement.classList.add("dark-mode");
		} else if (currentCookie === "auto") {
			if (prefersDarkScheme.matches) {
				// Change listener prefers-color-scheme
				document.documentElement.classList.add("dark-mode");
			}
		}
	} else if (window.matchMedia) {
		if (prefersDarkScheme.matches) {
			document.documentElement.classList.toggle("dark-mode");
		}
		mediaQueryList.addEventListener("change", _changeListener);
	}
})();

document.addEventListener("usernavready", () => {
	$('#_switch_auto_mode div[data-toggle="tooltip"]').tooltip({
		title: `<p class="tooltip-inner__content m-0">Selezionando <b>AUTO</b> il tema del sito sarà uguale alle impostazioni del tuo device.</p>`,
	});
	const isAuth = getCookie("authenticated");
	currentCookie = getCookie("color-scheme");

	if (!isAuth) {
		setCookie("color-scheme", "auto", 365);
		mediaQueryList.addEventListener("change", _changeListener);
		if (prefersDarkScheme.matches) {
			document.documentElement.classList.add("dark-mode");
		} else {
			document.documentElement.classList.remove("dark-mode");
		}
	}

	const themeSwitcher = document.querySelector("div.theme-switcher");
	if (themeSwitcher) {
		themeSwitcher.classList.remove("d-none");
	}

	if (currentCookie && isAuth) {
		if (currentCookie === "auto") {
			_switchActiveClass("#_switch_auto_mode");
			mediaQueryList.addEventListener("change", _changeListener);
		} else if (currentCookie === "light") {
			_switchActiveClass("#_switch_light_mode");
		} else if (currentCookie === "dark") {
			_switchActiveClass("#_switch_dark_mode");
		}
	}

	// Click Event
	const switchLightMode = document.querySelector("div#_switch_light_mode");
	const switchAutoMode = document.querySelector("div#_switch_auto_mode");
	const switchDarkMode = document.querySelector("div#_switch_dark_mode");

	if (switchLightMode) {
		switchLightMode.addEventListener("click", (e) => {
			e.stopPropagation();
			_switchActiveClass("#_switch_light_mode");
			setCookie("color-scheme", "light", 365);
			document.documentElement.classList.remove("dark-mode");
			mediaQueryList.removeEventListener("change", _changeListener);
		});
	}
	if (switchAutoMode) {
		switchAutoMode.addEventListener("click", (e) => {
			e.stopPropagation();
			_switchActiveClass("#_switch_auto_mode");
			setCookie("color-scheme", "auto", 365);
			if (prefersDarkScheme.matches) {
				document.documentElement.classList.add("dark-mode");
			} else {
				document.documentElement.classList.remove("dark-mode");
			}
			mediaQueryList.addEventListener("change", _changeListener);
		});
	}
	if (switchDarkMode) {
		switchDarkMode.addEventListener("click", (e) => {
			e.stopPropagation();
			_switchActiveClass("#_switch_dark_mode");
			setCookie("color-scheme", "dark", 365);
			document.documentElement.classList.add("dark-mode");
			mediaQueryList.removeEventListener("change", _changeListener);
		});
	}
});
